import { DatePickerWithRange } from "@/common/components/ui/dateRangePicker";
import { useFilterDate } from "@/common/hooks/useFilterDate";
import { DashboardFilterProps } from "@/features/company/types/dashboards/dashboard.type";

const DashboardFilterDateRangeBadge = ({ filters, setFilters }: DashboardFilterProps) => {
  const { date } = useFilterDate(filters);

  return (
    <DatePickerWithRange
      date={date}
      setDate={(date) => setFilters((params) => ({ ...params, date }))}
      buttonClassName="bg-blue-200/20 rounded-xl shadow-none"
    />
  );
}

export default DashboardFilterDateRangeBadge;
